import React, { useCallback, useMemo, useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import TableCustomerCare from "./tableCustomerCare";
import { useCustomerCareList } from "../../hooks/useCustomerCare";
import useDebounce from "../../hooks/useDebounce";

const TABLE_HEADERS = [
  { label: "", key: "action" },
  { label: "STT", key: "stt" },
  { label: "Mã KH", key: "code" },
  { label: "Tên khách hàng", key: "name" },
  { label: "Số điện thoại", key: "phone" },
  { label: "Email", key: "email" },
  { label: "Phân loại", key: "customerType" },
  { label: "Số giao dịch", key: "transactionCount" },
  { label: "Dự án quan tâm", key: "wishlistCount" },
  { label: "Dự án đã giao dịch", key: "transactedProjectCount" },
  { label: "Giá trị xếp hạng", key: "rankScore" },
  { label: "Xếp hạng", key: "rank" },
];

export default function CustomerCare() {
  const [search, setSearch] = useState("");
  const [rank, setRank] = useState(null);
  const [wishlistProjectId, setWishlistProjectId] = useState([]);
  const [transactedProjectId, setTransactedProjectId] = useState([]);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc");
  const debouncedSearch = useDebounce(search, 500);

  // Chu kỳ sắp xếp: mặc định -> giảm dần -> tăng dần -> mặc định.
  const handleSort = useCallback(
    (key) => {
      if (sortBy !== key) {
        setSortBy(key);
        setSortOrder("desc");
        return;
      }
      if (sortOrder === "desc") {
        setSortOrder("asc");
      } else {
        setSortBy(null);
        setSortOrder("desc");
      }
    },
    [sortBy, sortOrder],
  );

  const {
    customerCareData,
    totalPages,
    setCurrentPage,
    isLoading,
    isRefetching,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useCustomerCareList(
    debouncedSearch,
    null,
    rank,
    wishlistProjectId,
    transactedProjectId,
    sortBy,
    sortOrder,
  );

  const handlePageChange = useCallback(
    (selectedPage) => {
      setCurrentPage(selectedPage.selected + 1);
    },
    [setCurrentPage],
  );

  const tableData = useMemo(
    () => ({
      headers: TABLE_HEADERS,
      data: customerCareData,
    }),
    [customerCareData],
  );

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Chăm sóc khách hàng
          </Text>
        </Flex>
      </Flex>

      <Box mt={{ base: "23px" }}>
        <TableCustomerCare
          tableData={tableData}
          search={search}
          setSearch={setSearch}
          rank={rank}
          setRank={setRank}
          wishlistProjectId={wishlistProjectId}
          setWishlistProjectId={setWishlistProjectId}
          transactedProjectId={transactedProjectId}
          setTransactedProjectId={setTransactedProjectId}
          sortBy={sortBy}
          sortOrder={sortOrder}
          onSort={handleSort}
          totalPages={totalPages}
          isLoading={isLoading}
          isRefetching={isRefetching}
          currentPage={currentPage}
          entries={entries}
          startEntry={startEntry}
          endEntry={endEntry}
          handlePageChange={handlePageChange}
        />
      </Box>
    </Box>
  );
}
